const slash = string => string ? `/${string}` : '';
const lowercase = string => 'string' === typeof string ? string.toLowerCase() : '';

export const categoryLink = path => (path ? `/${lowercase(path)}` : '/');
export const threadLink = (path, id = '', page = '') => `/${lowercase(path)}${slash(id)}${slash(page)}`;
export const authorPostsLink = userId => `/author-posts/${userId}`;
